var _desc, _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Integration Maquette UI UX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wireframes and polished interface blocks.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10395c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#072035"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    rx: 18,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 70,
    width: 236,
    height: 220,
    rx: 12,
    fill: "none",
    stroke: "#6ab4e4",
    strokeWidth: 2,
    strokeDasharray: "8 6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 70,
    width: 236,
    height: 220,
    rx: 12,
    fill: "#103858",
    stroke: "#ffd700",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 96,
    width: 192,
    height: 26,
    rx: 6,
    fill: "none",
    stroke: "#8cd0ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 138,
    width: 120,
    height: 72,
    rx: 8,
    fill: "none",
    stroke: "#8cd0ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 138,
    width: 60,
    height: 72,
    rx: 8,
    fill: "none",
    stroke: "#8cd0ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 224,
    width: 192,
    height: 40,
    rx: 8,
    fill: "none",
    stroke: "#8cd0ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 96,
    width: 192,
    height: 26,
    rx: 6,
    fill: "#1a5e8d"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 138,
    width: 192,
    height: 94,
    rx: 10,
    fill: "#174f76"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 244,
    width: 140,
    height: 24,
    rx: 12,
    fill: "#ffd700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiux);
export default __webpack_public_path__ + "static/media/uiux.b103494eb2b7608891e5bb5ca8281c5b.svg";
export { ForwardRef as ReactComponent };